export default {
	history: {
		saveInFile: "Зберегти в файл",
		server: "Сервер:",
		lastHistory: "Остання історія",
		historyFilesList: "Список файлів історії",
		noCronOnCurrentServer: "На поточному сервері немає cron-у",
	},
	scheduler: {
		schedulerStructure: "Структура розкладу",
		cronHelp: "Допомога по CRON",
		schedulerConsistOfPackeges: "Розклад складається з пакетів, які заплановані запускатися в певний час.",
		eachPackageConsistsOfAnArbitraryNumber: "Кожен пакет складається з довільної кількості кроків.",
		stepIsATemplateThatWorksWithSpecificTasks: "Крок є шаблоном, який працює з завданнями конкретної програми.",
		stepCreate: "Створення кроку",
		forStepCreateNeedSelectApp: "Для створення кроку необхідно обрати програму.",
		AfterThatListOfTemplatesCreatedForThisWillAppear: "Після цього з'явиться список шаблонів, які створені для цієї програми.",
		ifNeededSelectBaseYouNeedSelectItFromCurrentList: "Якщо в завданні потрібно вказати базу, її потрібно буде вибрати з наступного списку баз програми.",
		stepEdit: "Редагування кроку",
		stepEditError: "Не можна редагувати бази створеного кроку, але можна видалити конкретний, і на його місці створити новий крок.",
		stepsCanBeRearranged: "Кроки можна переставляти місцями і додавати / видаляти з будь-якого місця пакета шляхом відповідних кнопок.",
		stepsEditWarning: "Якщо один з кроків пакета був створений на основі шаблону, який потім був змінений, навпроти цього пакета в цілому і кроку зокрема буде відповідний запис.",
		packageCanHaveOneSchedule: "Пакет може мати одне розклад, яке можна виставити на спеціальній формі.",
		packagesCanBeSortedByNameOrDate: "Пакети можна сортувати за їх назвою або за годиною їх запуску в розкладі.",
		newChanges: "Нові зміни",
		version: "версія",
		nowYouCanCreateTasksCopy: "З'явилася можливість створювати копії завдань при створенні / редагуванні кроку на підставі шаблону.",
		allBasesAndQuanityAdded: "Праворуч від завдання знаходяться два нових елементи: кнопка 'всі бази' і поле 'кількість'.",
		allBasesElementCanCreateAllCopiesOfTasks: " 'Вci бази' створить стільки копій завдання, скільки в програмі баз і автоматично прив'яже все копії відповідних баз. Видно тільки в тому випадку, якщо завдання необхідно ввести базу.",
		quanityElementCreateCopiesOfCurrentTask: " 'Кількість' створить копії поточного завдання введену кількість разів (існуюче завдання враховується при створенні).",
		cronExportPreview: "Прев'ю експорту CRON",
		cancel: "Скасувати",
		export: "Експорт",
		server: "Сервер:",
		cronCreate: "Створити CRON",
		cronExport: "Експорт CRON",
		cronEdit: "Редагування CRON",
		templatesEdit: "Редагування шаблонів",
		onCurrentServerCronNotFound: "На даному сервері не знайдений CRON.",
		cronNotExported: "CRON не экспортований"
	}
};
